import ItemNavigation from 'components/ui/ItemNavigation';
import Title from 'components/ui/TitleForSection';
import { useAppContext } from 'context/state';
import { useTariffContext } from 'context/tariff_state';
import { useVacancyContext } from 'context/vacancy_state';
import { PurchaseOrder, PurchaseProduct } from 'data/interfaces/Common';
import { useHashNavigation } from 'hooks/useHashNavigation';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/router';
import { FC, useEffect, useState } from 'react';
import { AppMetricaEvent, sendToMetrika } from 'utils/sendToMetrics';
import History from './History';
import styles from './index.module.scss';
import MyTariffs from './MyTariffs';
import Offers from './Offers';

export enum ShopPages {
  AllOffers = 'allOffers',
  MyTariffs = 'myTariffs',
  History = 'history',
}

interface Props {
  products: PurchaseProduct[];
  orders: PurchaseOrder[];
}

const Shop: FC<Props> = ({ products, orders }) => {
  const t = useTranslations();
  const tariffContext = useTariffContext();
  const [page, setPage] = useState<ShopPages>(ShopPages.AllOffers);
  const vacancyContext = useVacancyContext();
  const { isTabletWidth } = useAppContext().size;
  const router = useRouter();

  const { activeItem, setActiveItem } = useHashNavigation(ShopPages, ShopPages.AllOffers);

  useEffect(() => {
    sendToMetrika(AppMetricaEvent.GoToStore);
    vacancyContext.setVacancies();
    tariffContext.setProducts(products ?? []);
    tariffContext.setOrders(orders ?? []);
  }, []);

  useEffect(() => {
    if (router.query.page) {
      setPage(router.query.page as ShopPages);
    }
  }, [router]);

  const navSet = (() => {
    const hirerObj = [ShopPages.AllOffers, ShopPages.MyTariffs, ShopPages.History];

    const result = hirerObj.map((page) => {
      switch (page) {
        case ShopPages.AllOffers:
          return { name: t('all_offers'), type: page };
        case ShopPages.MyTariffs:
          return { name: t('my_tarrifs'), type: page };
        case ShopPages.History:
          return { name: t('purchase_history'), type: page };
        default:
          throw new Error('Invalid page type: ' + page);
      }
    });
    return result;
  })();

  const getPage = (() => {
    switch (activeItem) {
      case ShopPages.AllOffers:
        return <Offers />;
      case ShopPages.MyTariffs:
        return <MyTariffs setPage={setActiveItem} />;
      case ShopPages.History:
        return <History setPage={setActiveItem} />;
      default:
        throw new Error('Invalid page type:' + page);
    }
  })();

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <Title title={t('shop')} onBackClick={() => router.back()} />
        <ItemNavigation
          onAllWidth={isTabletWidth}
          className={styles.itemNav}
          activeItem={activeItem}
          items={navSet}
          onClick={setActiveItem}
        />
        {getPage}
      </div>
    </div>
  );
};

export default Shop;
